export default function repairColorMode() {
  const storedColorMode = localStorage.getItem("chakra-ui-color-mode");
  const colorMode = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  if (storedColorMode !== colorMode) {
    localStorage.setItem("chakra-ui-color-mode", colorMode);
  }
}
